import axios from "axios";

/* UAT Backend */
// const BaseURL = "http://uat.kiu.lk:5001/api";

/* Production HR Backend */
const BaseURL2 = "https://hr-backend.kiu.lk/people";

/* Development Backend */
// const BaseURL = "http://192.168.220.118:8080/api/auth";


/* Development Hello Backend */

/* Production Backend */
const BaseURL = "https://intcrm-backend.kiu.lk/api/auth";


export const api = axios.create({
  baseURL: BaseURL,
});

export const hrApi = axios.create({
  baseURL: BaseURL2,
});
